module.exports = __webpack_public_path__ + "img/loop_2.de8c3f7e.svg";